import { Dashboard, Localizations } from '@/components';

export const LocalizationsListPage = (): JSX.Element => (
  <Dashboard>
    <Localizations />
  </Dashboard>
);
